import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroNivelDetallePage } from './busqueda-tesoro-nivel-detalle';

@NgModule({
  declarations: [
    BusquedaTesoroNivelDetallePage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroNivelDetallePage),
  ],
})
export class BusquedaTesoroNivelDetallePageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-nivel-detalle/busqueda-tesoro-nivel-detalle.module.ts